import { classListSupport, hasClass } from './hasClass.js';
var addClass = classListSupport
  ? function(el, str) {
    if (!hasClass(el, str)) { el.classList.add(str); }
  }
  : function(el, str) {
    if (!hasClass(el, str)) { el.className += ' ' + str; }
  };

export { addClass };



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/addClass.js